<template>
	<div v-if="$store.hasUserBugReporterRole" class="flex items-center text-yellow-500 cursor-default text-strong-base">
		<BaseIcon name="mono/warn" class="mr-8" />
		{{ text }}
	</div>
	<BaseButton
		v-else
		class="link-yellow text-strong-base"
		@click="$routerHelpers.navigateToWorkspaceSettings('subscription-plan')"
	>
		<template #icon>
			<BaseIcon name="mono/warn" />
		</template>
		{{ text }}
	</BaseButton>
</template>

<script>
export default {
	name: 'WorkspaceSubscriptionProblemMessage',
	computed: {
		text() {
			const problem = this.$workspaceSubscription.problem
			if (!problem) return ''
			switch (problem) {
				case 'trial-ended':
					return `${this.$workspaceSubscription.plan.name || 'Workspace'} trial ended`
				case 'subscription-paused':
					return 'Subscription paused'
				case 'subscription-ended':
					return 'Subscription ended'
				case 'free-plan-ended':
					return 'Free plan ended'
				default:
					return ''
			}
		},
	},
}
</script>
